import React from "react";
import Phone from "./Phone";
import PickList from "./PickList";
import TextArea from "./TextArea";
import TextInput from "./TextInput";
import Number from "./Number";
import Email from "./Email";
import LongNumber from "./LongNumber";
import Decimal from "./Decimal";
import Percentage from "./Percentage";
import Currency from "./Currency";
import DatePick from "./DatePick";
import DateTime from "./DateTime";
import OnAndOffField from "./OnAndOffField";
import Multiselect from "./MultiSelect";
import Checkbox from "./Checkbox";
import DrillDown from "./DrillDown";
import LookupField from '../LookupField';
import TimePick from "./TimePick";
import TextHTML from './TextHTML';
import Radio from './Radio';
import MultiChoose from './MultiChoose';
import StepsTypeTagForReminder from './StepsTypeTagForReminder';
import Password from "./Password";
import FileUpload from "./FileUpload";
import ImageUpload from "./ImageUpload";
// import DateField from "./Fields/DateField";
// import OnAndOffField from "./Fields/OnAndOffField";


const FormInputFields = (props) => {  
  //console.log('props.type==',props.type)
  switch (props.type) {
    case "DrillDown":
      return <DrillDown {...props}/>;
    case "PickList":
      return <PickList {...props} />;
    case "Password":
      return <Password {...props} />
    case "Phone":
      return <Phone {...props} />;
    case "Email":
      return <Email {...props} />;
    case "TextArea":
      return <TextArea {...props} />;
    case "TextHTML":
      return <TextHTML {...props} />;      
    case "TextInput":
		  return <TextInput {...props}/>;
    case "PostalCode":
		  return <TextInput {...props}/>;
    case "Number":
      return <Number {...props}/>;  
    case "LongNumber":
      return <LongNumber {...props}/>;
    case "Decimal":
        return <Decimal {...props}/>;  
    case "Percentage":
        return <Percentage {...props}/>;  
    case "Currency":
        return <Currency {...props}/>;  
    case "DatePick":
        return <DatePick {...props}/>;
    case "Date":
        return <DatePick {...props}/>;
    case "DateTime":
          return <DateTime {...props}/>;
    case "Reminder":
          return <DateTime {...props}/>;
    case "TimePick":
          return <TimePick {...props} />       
    case "OnAndOffField":
        return <OnAndOffField {...props}/>;
    case "Multiselect":
      return <Multiselect {...props}/>;
    case "MultiSelect":
      return <Multiselect {...props}/>;
    case "MultiChoose":
      return <MultiChoose {...props}/>;    
    case "Checkbox":
      return <Checkbox {...props} />;
    case "FileUpload":
      return <FileUpload {...props}/>     
    case "ImageUpload":
      return <ImageUpload {...props}/>     
    case "Radio":
      return <Radio {...props} /> ; 
    case 'Lookup' :
        return <LookupField
              values={props.values}
              lookupWindowName={props.lookupWindowName}
              lookupWindowNameId={props.lookupWindowNameId}
              handleInputChange={e=>props.handleInputChange(e,props.attr1)}
              handleDelete={e=>props.handleDelete(e,props.attr1)}
              isNotes={props.isNotes}
              />
      break;
    case 'MultiLookup' :
      return <LookupField
              values={props.values}
              lookupWindowName={props.lookupWindowName}
              lookupWindowNameId={props.lookupWindowNameId}
              handleInputChange={e=>props.handleInputChange(e,props.attr1)}
              handleDelete={e=>props.handleDelete(e,props.attr1)}
              isNotes={props.isNotes}
              />
      break;
    case 'Email' :
      return <LookupField
              values={props.values}
              lookupWindowName={props.lookupWindowName}
              lookupWindowNameId={props.lookupWindowNameId}
              handleInputChange={e=>props.handleInputChange(e,props.attr1)}
              handleDelete={e=>props.handleDelete(e,props.attr1)}
              isNotes={props.isNotes}
              />
      break;
    case 'User' :
      return <LookupField
              values={props.values}
              lookupWindowName={props.lookupWindowName}
              lookupWindowNameId={props.lookupWindowNameId}
              handleInputChange={e=>props.handleInputChange(e,props.attr1)}
              handleDelete={e=>props.handleDelete(e,props.attr1)}
              isNotes={props.isNotes}
              />
      break; 
    case 'StepsTypeTagForReminder':
      return <StepsTypeTagForReminder {...props}/>            
    default :
       return  <TextInput {...props}/>;
      
  }
};
export default FormInputFields;